import { FloatingButton } from '@elfsight/widget-ui';
import { getInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

interface ReopenButton {
  onClick: () => void;
}
export const ReopenButton = ({ onClick }: ReopenButton) => {
  const {
    reopenButton,
    reopenButtonPosition,
    reopenButtonText,
    reopenButtonIcon,
    accentColor,
    renderThumbnailMode
  } = useSettings();

  const noContent = !reopenButtonText && !reopenButtonIcon?.url;
  const buttonText = noContent ? 'Button Text' : reopenButtonText;

  if (!reopenButton || renderThumbnailMode) return null;

  return (
    <FloatingButton
      color={accentColor}
      fontColor={getInvertedColor(accentColor)}
      iconOnly={!reopenButtonText && !!reopenButtonIcon?.url}
      iconLeft={reopenButtonIcon}
      onClick={onClick}
      font={{
        fontSize: 18,
        fontWeight: 'bold',
        fontStyle: 'normal'
      }}
      position={reopenButtonPosition}
    >
      {buttonText}
    </FloatingButton>
  );
};
